var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommentPlusSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3943 7.20933C13.3943 7.64096 13.5655 8.05492 13.8715 8.36003C14.1766 8.66608 14.5906 8.83725 15.0222 8.83725H16.1385C16.5701 8.83725 16.9841 8.66608 17.2892 8.36003C17.5953 8.05492 17.7664 7.64096 17.7664 7.20933V6.60468H18.3711C18.8027 6.60468 19.2167 6.43352 19.5218 6.12747C19.8278 5.82235 19.999 5.40839 19.999 4.97676C19.999 4.62141 19.999 4.21583 19.999 3.86048C19.999 3.42885 19.8278 3.0149 19.5218 2.70978C19.2167 2.40373 18.8027 2.23257 18.3711 2.23257H17.7664V1.62791C17.7664 1.19628 17.5953 0.782329 17.2892 0.477211C16.9841 0.171164 16.5701 0 16.1385 0C15.7832 0 15.3776 0 15.0222 0C14.5906 0 14.1766 0.171164 13.8715 0.477211C13.5655 0.782329 13.3943 1.19628 13.3943 1.62791V2.23257H12.7897C12.358 2.23257 11.9441 2.40373 11.639 2.70978C11.3329 3.0149 11.1617 3.42885 11.1617 3.86048V4.97676C11.1617 5.40839 11.3329 5.82235 11.639 6.12747C11.9441 6.43352 12.358 6.60468 12.7897 6.60468H13.3943V7.20933ZM14.7897 7.20933V5.907C14.7897 5.52188 14.4771 5.20932 14.092 5.20932H12.7897C12.7283 5.20932 12.6687 5.18514 12.625 5.14142C12.5813 5.0977 12.5571 5.03816 12.5571 4.97676V3.86048C12.5571 3.79909 12.5813 3.73955 12.625 3.69583C12.6687 3.65211 12.7283 3.62792 12.7897 3.62792H14.092C14.4771 3.62792 14.7897 3.31536 14.7897 2.93024V1.62791C14.7897 1.56652 14.8139 1.50698 14.8576 1.46326C14.9013 1.41954 14.9608 1.39535 15.0222 1.39535H16.1385C16.1999 1.39535 16.2594 1.41954 16.3032 1.46326C16.3469 1.50698 16.3711 1.56652 16.3711 1.62791V2.93024C16.3711 3.31536 16.6836 3.62792 17.0687 3.62792H18.3711C18.4325 3.62792 18.492 3.65211 18.5357 3.69583C18.5794 3.73955 18.6036 3.79909 18.6036 3.86048V4.97676C18.6036 5.03816 18.5794 5.0977 18.5357 5.14142C18.492 5.18514 18.4325 5.20932 18.3711 5.20932H17.0687C16.6836 5.20932 16.3711 5.52188 16.3711 5.907V7.20933C16.3711 7.27073 16.3469 7.33026 16.3032 7.37398C16.2594 7.41771 16.1999 7.44189 16.1385 7.44189H15.0222C14.9608 7.44189 14.9013 7.41771 14.8576 7.37398C14.8139 7.33026 14.7897 7.27073 14.7897 7.20933Z",
    fill: "url(#paint0_linear_160_2290)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7443 9.99992V11.4223C16.7443 12.985 15.5684 14.2706 14.0931 14.2706H9.0698C8.90236 14.2706 8.7405 14.3311 8.61399 14.4399L4.74421 17.7786V14.9683C4.74421 14.5832 4.43165 14.2706 4.04653 14.2706C2.57117 14.2706 1.39535 12.985 1.39535 11.4223V6.10409C1.39535 4.54129 2.57117 3.25571 4.04653 3.25571H10C10.3852 3.25571 10.6977 2.94315 10.6977 2.55803C10.6977 2.17291 10.3852 1.86035 10 1.86035C8.21771 1.86035 5.50607 1.86035 4.04653 1.86035C1.82326 1.86035 0 3.74966 0 6.10409V11.4223C0 13.5255 1.45396 15.2567 3.34885 15.6027V19.3023C3.34885 19.5748 3.50792 19.8232 3.75629 19.9367C4.00374 20.0502 4.29583 20.0083 4.50234 19.8307L9.32934 15.666H14.0931C16.3163 15.666 18.1396 13.7767 18.1396 11.4223V9.99992C18.1396 9.6148 17.827 9.30224 17.4419 9.30224C17.0568 9.30224 16.7443 9.6148 16.7443 9.99992Z",
    fill: "url(#paint1_linear_160_2290)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.4174 6.97641H7.20811C7.59323 6.97641 7.90579 6.66385 7.90579 6.27873C7.90579 5.89361 7.59323 5.58105 7.20811 5.58105H4.4174C4.03229 5.58105 3.71973 5.89361 3.71973 6.27873C3.71973 6.66385 4.03229 6.97641 4.4174 6.97641Z",
    fill: "url(#paint2_linear_160_2290)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.4174 10.6971H9.99882C10.3839 10.6971 10.6965 10.3846 10.6965 9.99944C10.6965 9.61432 10.3839 9.30176 9.99882 9.30176H4.4174C4.03229 9.30176 3.71973 9.61432 3.71973 9.99944C3.71973 10.3846 4.03229 10.6971 4.4174 10.6971Z",
    fill: "url(#paint3_linear_160_2290)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_160_2290",
    x1: 19.999,
    y1: 4.52074e-7,
    x2: 4.8299,
    y2: 16.6723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9DFC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85DDDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_160_2290",
    x1: 18.1396,
    y1: 1.86035,
    x2: -12.9968,
    y2: 36.0825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9DFC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85DDDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_160_2290",
    x1: 7.90579,
    y1: 5.58105,
    x2: 6.56944,
    y2: 9.98741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9DFC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85DDDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_160_2290",
    x1: 10.6965,
    y1: 9.30176,
    x2: 9.849,
    y2: 13.9592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9DFC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85DDDE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentPlusSmall);
export default __webpack_public_path__ + "static/media/comment-plus-small.7f211304005a6361cda39d9a6d3e9616.svg";
export { ForwardRef as ReactComponent };